import { Controller } from "@hotwired/stimulus"
import { emitSelected } from "../selection/selection_events"

/**
 * Emits an item:selected event when the user clicks (or calls select()).
 * Stateless — it simply fires the event. The receiver decides what to do.
 *
 * Usage:
 *   <div data-controller="selectable-item"
 *        data-selectable-item-type-value="content"
 *        data-selectable-item-item-id-value="42"
 *        data-selectable-item-target-name-value="newsletter_slot_1"
 *        data-action="click->selectable-item#select">
 *     ...card content...
 *   </div>
 */
export default class extends Controller {
  static values = {
    type: String,           // "content", "product_item", etc.
    itemId: Number,         // the primary id to emit
    targetName: String,     // optional: receiver name filter
    scope: String,          // optional: CSS selector for scope override
    meta: Object,           // optional: extra data passed through in the event
  }

  select() {
    const scope = this.hasScopeValue ? this.scopeValue : undefined;
    const target = this.hasTargetNameValue ? this.targetNameValue : undefined;

    emitSelected({
      type: this.typeValue,
      id: this.itemIdValue,
      target,
      ...(this.hasMetaValue ? { meta: this.metaValue } : {}),
    }, this.element, scope);
  }
}
